import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPen20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPen20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m16.89 5.89-1.769-1.769-1.283 1.283 1.77 1.77zM4.946 14.296l7.832-7.831 1.769 1.769-7.832 7.832-2.268.499zm2.52 3.14L17.95 6.951a1.5 1.5 0 0 0 0-2.121l-1.77-1.77a1.5 1.5 0 0 0-2.12 0L3.574 13.547l-.761 3.46a1 1 0 0 0 1.191 1.192zm5.284-.936a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPen20);
